import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ICakeCartLine } from '../../../cart/models/cart/i-cake-cart-line';


@Component({
  standalone: false,
  selector: 'mobile-cart-apply-once-item',
  templateUrl: './mobile-cart-apply-once-item.component.html',
  styleUrls: ['../mobile-cart-product-item/mobile-cart-product-item.component.scss']
})
export class MobileCartApplyOnceItemComponent {
  @Input() orderLine: ICakeCartLine;
  @Input() currency: string;

  @Output() onRemoveOrderLine = new EventEmitter<ICakeCartLine>();
}
